import {i18n} from "@mytour/platform";
import {Field} from "@mytour/ui/form";
import {Splitter} from "@mytour/ui/layout";
import type {UseFormReturn} from "react-hook-form";
import type {Step3ShiftingPriceForm} from "../Step3ShiftingPrice";

type Props = {
  index: number;
  hookForm: UseFormReturn<Step3ShiftingPriceForm>;
  disabled: boolean;
};

export function ZoneLine({index, hookForm, disabled}: Props) {
  const {
    watch,
    formState: {errors},
  } = hookForm;
  const zones = watch("zones");

  const {t: translate} = i18n;

  const ignoreShifting = index === zones.length - 1;
  const min = index <= 0 ? 0 : (zones[index - 1]?.distance ?? 0);
  //const max = ignoreShifting ? undefined : "" + zones[index + 1].distance;

  const zoneNumber = index + 1;
  const namePrefix = `zones[${index}].`;
  const minLabel = min || min === 0 ? `${min}` : "?";

  return (
    <>
      <Splitter>
        <Field
          name={`${namePrefix}label`}
          type="text"
          label={`${translate("myTourApp.platformUser.shiftingZoneLabel")} ${zoneNumber}`}
          hookForm={hookForm}
          disabled={disabled}
          error={errors.zones?.[index]?.label}
        />
        <Splitter>
          <Field
            name={`${namePrefix}distance`}
            type="number"
            step="1"
            min="0"
            label={`de ${minLabel} à`}
            hookForm={hookForm}
            disabled={disabled || ignoreShifting}
            error={errors.zones?.[index]?.distance}
          />

          <Field
            name={`${namePrefix}amount`}
            type="decimal"
            min="0"
            label={`${translate("myTourApp.platformUser.shiftingZoneAmountLabel")}`}
            hookForm={hookForm}
            disabled={disabled}
            error={errors.zones?.[index]?.amount}
          />
        </Splitter>
      </Splitter>
    </>
  );
}
